import React from "react";
import moment from "moment";
import Text from "../../../components/text";
import Subtitle from "../../../components/subtitle";

interface IProps {
  data: any; // se quiser tipar depois, melhor
}

const CardVagaMobile: React.FC<IProps> = ({ data }) => {
  return (
    <div className="w-full rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm mb-3">
      <div className="px-5 pt-3.5 pb-2 border-b border-gray-100 flex justify-between items-center">
        <Text className="!text-[14px] !font-semibold">
          Vaga: {data.vaga}
        </Text>

        <Text className="!text-[12px] !text-[rgba(0,0,0,.5)]">
          {moment(data.data).utc().format('DD/MM/YYYY')}
        </Text>
      </div>

      <div className="px-5 py-2 flex justify-between items-center">
        <div>
          <Subtitle className="!text-[11px] !text-gray-400">
            Situação
          </Subtitle>
          <Text className="!text-[13px]">{data.situacao}</Text>
        </div>

        <div className="text-right">
          <Subtitle className="!text-[11px] !text-gray-400">
            Tipo
          </Subtitle>
          <Text className="!text-[13px]">{data.origemVaga}</Text>
        </div>
      </div>

      <div className="bg-[#F3F4F6] mx-4 mt-2 mb-2 px-4 py-3 rounded-md flex flex-col gap-3">
        <div>
          <Subtitle className="!text-[11px]">Efetivo</Subtitle>
          <Text className="!text-[14px] !font-semibold">
            {data.efetivo
              ? `${data.efetivo.re} - ${data.efetivo.nome}`
              : "—"}
          </Text>
        </div>
        <div className="flex justify-between max-[500px]:flex-col max-[500px]:gap-3">
          <div>
            <Subtitle className="!text-[11px]">Cobertura</Subtitle>
            <Text className="!text-[14px] !font-semibold">
              {data.cobertura
                ? `${data.cobertura.re} - ${data.cobertura.nome}`
                : "—"}
            </Text>
          </div>

          <div>
            <Subtitle className="!text-[11px] !text-end max-[500px]:!text-start">Situação Cobertura</Subtitle>
            <Text className="!text-[14px] !font-semibold !text-end max-[500px]:!text-start">
              {data.situacaoCobertura || "—"}
            </Text>
          </div>
        </div>
      </div>

      <div className="px-5 pb-3 flex justify-between gap-2">
        <div>
          <Subtitle className="!text-[11px] !text-[#4C7AFB]">
            Horário Vaga
          </Subtitle>
          <Text className="!text-[13px]">
            {data.horarioVaga
              ? `${data.horarioVaga.entrada} ${data.horarioVaga.saidaRefeicao} ${data.horarioVaga.retornoRefeicao} ${data.horarioVaga.saida}`
              : "—"}
          </Text>
        </div>

        <div>
          <Subtitle className="!text-[11px] !text-[#ffa62b] !text-end">
            Horário Ponto
          </Subtitle>
          <Text className="!text-[13px] !text-end">
            {data.horarioPonto
              ? `${data.horarioPonto.entrada} ${data.horarioPonto.saidaRefeicao} ${data.horarioPonto.retornoRefeicao} ${data.horarioPonto.saida}`
              : "—"}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default CardVagaMobile;